export default __webpack_public_path__ + "static/media/debit-interest-configuration.36868a7a.svg";